export const STATIC_LABELS: Record<string, string> = {
  account: "Account",
  certifications: "Certifications",
  dashboard: "Dashboard",
  edit: "Edit",
  entrance: "Entrance",
  entrances: "Entrances",
  forms: "Forms",
  permits: "Permits",
  inbox: "Operational Inbox",
  new: "New",
  profile: "Account",
  qr: "QR",
  site: "Sites",
  signins: "Sign Ins",
  subscription: "Subscription",
  "sign-in-activity": "Sign In Activity",
  workers: "Workers",
  templates: "Templates",
};

export const SKIP_LINK_SEGMENTS = new Set(["new"]);
export const ID_LIKE_SEGMENT = /^[0-9a-f-]{8,}$/i;
